<template>
  <div class="view color_333">
    <h1 style="text-align: center; font-size: 26px">中华人民共和国海关出口货物报关单</h1>
    <div class="tipsTop">
      <span>预录入编号：</span>
      <span>海关编号：</span>
      <span>（海沧港区）</span>
      <span>仅供核对用</span>
    </div>
    <el-card class="hs">
          <el-row>
            <el-col :span="20">
              <table border="0" style="border-collapse:separate; border-spacing:0px 0px;"
                     class="table_wrap mb_10">
                <tr class="">
                  <td>
                    申报地海关
                  </td>
                  <td colspan="3" class="newleft">
<!--                    <el-select v-model="order.port" filterable @change="$forceUpdate()" style="width: 100%">-->
<!--                      <el-option v-for="item in sbdhgList" :key="item.code" :label="item.name" :value="item.code"></el-option>-->
<!--                    </el-select>-->
                    <input type="text" v-model="order.port" style="width: 100%">
                  </td>
                  <td>
                    申报状态
                  </td>
                  <td colspan="3" class="newleft">
                    {{order.status == 1? '已完成':
                    order.status == 2? '待补充信息':
                    order.status == 3? '受理中':
                    order.status == 4? '待签函':
                    order.status == 5? '待报关':
                    order.status == 6? '待收汇':
                    order.status == 7? '待寄发票':
                    order.status == 8? '待退税':
                    order.status == 9? '已退税':
                    order.status == 10? '待受理':
                    order.status == 11? '取消订单':
                    order.status == 12? '报送中':
                    order.status == 13? '草稿':
                    order.status == 14? '初审通过':
                    order.status == 15? '已放行':
                    order.status == 16? '结关':'报送失败'
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    统一编号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.uniformnumbers" style="width: 100%">
                  </td>
                  <td>
                    预录入编号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.prenumbers" style="width: 100%">
                  </td>
                </tr>
                <tr>
                  <td>
                    海关编号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.customsnumbers" style="width: 100%">
                  </td>
                  <td>
                    出境关别
                  </td>
                  <td colspan="3"   class="newleft">
<!--                  <td colspan="3" @click="ExitPortSelected" class="newleft">-->
                    {{order.access_port}}
                  </td>
                </tr>
                <tr>
                  <td>
                    备案号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.recordnumber" style="width: 100%">
                  </td>
                  <td>
                    合同协议号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.contract_type_info.contractno">
                    <!--                {{order.contract_type_info.contractno}}-->
                  </td>
                </tr>
                <tr>
                  <td>
                    出口日期
                  </td>
                  <td colspan="3" class="newleft">
                    <el-date-picker v-model="order.sailschedule" type="date" :clearable="false" value-format="yyyyMMdd"></el-date-picker>
                    <!--                {{order.sailschedule}}-->
                  </td>

                  <td>
                    申报日期
                  </td>
                  <td colspan="3" class="newleft">
                    <el-date-picker v-model="order.apply_at1" type="date" :clearable="false" value-format="yyyyMMdd" readonly></el-date-picker>
                  </td>
                </tr>
                <tr>
                  <td>
                    境内收发货人
                  </td>
                  <td colspan="2">
                    {{order.registration}}
                  </td>
                  <td colspan="2">
                    {{order.custom}}
                  </td>
                  <td>

                  </td>
                  <td colspan="2" class="newleft">
<!--                    <input @click="contacterDialog = true"   type="text" v-model="order.contact.contactid_company_show" style="width: 100%" readonly>-->
                                    {{order.contact.contactid_company_show}}
                  </td>
                </tr>

                <tr>
                  <td>
                    境外收发货人
                  </td>
                  <td colspan="2">
                    {{order.registration}}
                  </td>
                  <td colspan="2">
                    {{order.custom}}
                  </td>
                  <td>

                  </td>

<!--                  <td colspan="2" @click="receiverDialog = true" class="newleft">-->
                  <td colspan="2"   class="newleft">
                    {{order.receiver.receiverid_company_show}}
                  </td>

                  <!--                  <td colspan="2" class="newleft">-->
                  <!--                    {{order.contact.contactid_company_show}}-->
                  <!--                  </td>-->
                  <!--                  <td>-->
                  <!--                  </td>-->
                  <!--                  <td colspan="4" class="newleft">-->
                  <!--                  </td>-->
                  <!--                  <td colspan="3" class="newleft">-->
                  <!--                  </td>-->
                </tr>

                <tr>
                  <td>
                    生产销售单位
                  </td>
                  <td colspan="2">
                    {{order.registration}}
                  </td>
                  <td colspan="2">
                    {{order.custom}}
                  </td>
                  <td>

                  </td>
                  <!--                  <td colspan="4" class="newleft">-->
                  <!--                  </td>-->
                  <!--                  <td colspan="3" class="newleft">-->
                  <!--                  </td>-->
                </tr>
                <tr>
                  <td>
                    申报单位
                  </td>
                  <td colspan="2">
                    {{order.registration}}
                  </td>
                  <td colspan="2">
                    {{order.custom}}
                  </td>
                  <td>

                  </td>

                  <td colspan="2" class="newleft">
                    {{order.contact.contactid_company_show}}
                  </td>
                </tr>
                <tr>
                  <td>
                    运输方式
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.shipping_type" style="width: 100%">
                  </td>
                  <td>
                    运输工具名称
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.conveyance_name" style="width: 100%">
                  </td>
                  <td>
                    航次号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.voyage_number" style="width: 100%">
                  </td>
                </tr>
                <tr>
                  <td>
                    提运单号
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.loading_bill_number" style="width: 100%">
                    <!--                {{order.loading_bill_number}}-->
                  </td>
                  <td>
                    监管方式
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.trade_approach_code" style="width: 100%">
                  </td>
                  <td>
                    征免性质
                  </td>
                  <td class="newleft">
                  </td>
                </tr>
                <tr>
                  <td>
                    许可证号
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.allownumber" style="width: 100%">
                  </td>
                  <td>
                    运抵国（地区）
                  </td>
                  <td class="newleft">
<!--                    <el-select v-model="order.destcountry" default-first-option filterable style="width: 100%">-->
<!--                      <el-option v-for="(aimItem,aimIndex) of countryData" :key="aimIndex" :label="aimItem.name" :value="aimItem.code"/>-->
<!--                    </el-select>-->
                    {{order.destcountry}}
                    <!--                {{order.destcountry}}-->
                  </td>
                  <td>
                    指运港
                  </td>
                  <td class="newleft">
<!--                    <el-select v-model="order.loading_port" filterable default-first-option placeholder="请选择">-->
<!--                      <el-option v-for="(entItem,entIndex) of entreportData" :key="entIndex" :label="entItem.port_ch" :value="entItem.port_ch"/>-->
<!--                    </el-select>-->
                    {{order.loading_port}}
                    <!--                {{order.loading_port}}-->
                  </td>
                  <td>
                    成交方式
                  </td>
                  <td class="newleft">
                    {{order.transmode}}
                  </td>
                </tr>
                <tr>
                  <td>
                    运费
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.priceterm_info_fare" style="width: 100%">
                    <!--                {{order.priceterm_info.fare}}-->
                  </td>
                  <td>
                    保险费
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.priceterm_info_premium" style="width: 100%">
                    <!--                {{order.priceterm_info.premium}}-->
                  </td>
                  <td>
                    杂费
                  </td>
                  <td class="newleft">
                  </td>
                  <td>
                    件数
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.packcount" style="width: 100%">
                    <!--                {{order.packcount}}-->
                  </td>
                </tr>
                <tr>
                  <td>
                    包装种类
                  </td>
                  <td colspan="2" class="newleft">
<!--                    <el-select @change="packagesChange" v-model="order.package1.package" style="width: 100%">-->
<!--                      <el-option v-for="(pacItem,pacIndex) of packagesData" :key="pacIndex" :label="pacItem.ch" :value="pacItem.ch" />-->
<!--                    </el-select>-->
                    {{order.package1.package.ch}}
                    <!--                    {{order.package1.package}}-->
                    <!--                    <el-select v-model="order.port" filterable @change="$forceUpdate()" style="width: 100%">-->
                    <!--                      <el-option v-for="item in sbdhgList" :key="item.code" :label="item.name" :value="item.code"></el-option>-->
                    <!--                    </el-select>-->
                  </td>
                  <td class="">
                    <!--                    其他包装（按钮？）-->
                    <el-button type="primary" style="width: 100%" @click="packagingDialogVisibleBtn">其他包装</el-button>
                  </td>
                  <td>
                    毛重（KG）
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.gwkg" style="width: 100%">
                  </td>
                  <td>
                    净重
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.nwkg" style="width: 100%">
                  </td>
                </tr>
                <tr>
                  <td>
                    贸易国别（地区）
                  </td>
                  <td class="newleft">
<!--                    <el-select v-model="order.trade_country" default-first-option filterable style="width: 100%">-->
<!--                      <el-option v-for="(aimItem,aimIndex) of countryData" :key="aimIndex" :label="aimItem.name" :value="aimItem.code"/>-->
<!--                    </el-select>-->
                                    {{order.trade_country}}
                  </td>
                  <td>
                    集装箱数
                  </td>
                  <td class="newleft">
                    <input type="text" v-model="order.containernum" style="width: 100%">
                  </td>
                  <td>
                    随附单证
                  </td>
                  <td colspan="3" class="newleft">
                  </td>
                </tr>
                <tr>
                  <td>
                    收货人地址
                  </td>
<!--                  <td colspan="3" @click="receiverDialog = true" class="newleft">-->
                  <td colspan="3"   class="newleft">
                    {{order.receiver.receiverid_country_show}};{{order.receiver.receiverid_addr_show}};{{order.receiver.receiverid_company_show}};
                  </td>
                  <td>
                    离境口岸
                  </td>
                  <td colspan="3" class="newleft">
                    <!--                    <input type="text" v-model="order.leave_Port" style="width: 100%">-->
                    <!--                    <div @click="leavePortDialog = true">-->
                    <!--                      <el-input v-model="order.leave_Port" placeholder="请选择离境口岸" readonly suffix-icon="el-icon-search"></el-input>-->
                    <!--                    </div>-->
                    <!--                    <input @click="contacterDialog = true"   type="text" v-model="order.contact.leave_Port" style="width: 100%" readonly>-->
<!--                    <input @click="leavePortDialog = true"   type="text" v-model="order.leave_Port" style="width: 100%" readonly>-->
                    {{order.leave_Port}}
                  </td>
                </tr>
                <tr>
                  <td>
                    报关单类型
                  </td>
                  <td colspan="2" class="newleft">
<!--                    <el-select v-model="order.entrytype" style="width: 100%">-->
<!--                      <el-option v-for="(item, index) of bgdlxList" :key="index" :label="item.name" :value="item.code"/>-->
<!--                    </el-select>-->
                    {{order.entrytype}}
                  </td>
                  <td>
                    出货备注
                  </td>
                  <td colspan="3" class="newleft">
                    <input type="text" v-model="order.memo" style="width: 100%">
                    <!--                {{order.memo}}-->
                  </td>
                  <td colspan="3" class="newleft">
                    <el-button type="primary" style="width: 100%" @click="priceDialogVisible = true">价格说明</el-button>
                  </td>
                </tr>
                <tr>
                  <td>
                    标记唛码
                  </td>
                  <td colspan="6" class="newleft">
                    <input type="text" v-model="order.marks" style="width: 100%">
                    <!--                {{order.marks}}-->
                  </td>
                  <td>
                    <el-button type="primary" style="width: 100%">业务事项</el-button>
                  </td>
                </tr>
              </table>

              <div class="mb_10">
                <el-table @row-click="rowClick" :data="products"
                          border
                          style="width: 100%"
                          :header-cell-style="{
                      'background-color': '#303133',
                      'color': '#fff',
                      'text-align':'center'
                  }">
                  <el-table-column width="55"
                                   label="项号"
                  >
                <span slot-scope="r">
                  {{r.$index + 1}}
                </span>
                  </el-table-column>
                  <el-table-column prop="sort"
                                   label="备案序号">
                  </el-table-column>
                  <el-table-column prop="hscode"
                                   label="商品编号">
                  </el-table-column>
                  <el-table-column prop=""
                                   label="检验检疫名称">
                  </el-table-column>
                  <el-table-column prop="ch"
                                   label="商品名称">
                  </el-table-column>

                  <el-table-column prop="factors" label="规格" width="100">
                    <template slot-scope="scope">
                      <el-tooltip effect="dark" :content="scope.row.factors1" placement="bottom">
                        <p style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden">{{scope.row.factors1}}</p>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <!--              <el-table-column prop="factors"-->
                  <!--                               label="规格">-->
                  <!--              </el-table-column>-->
                  <el-table-column prop="qtt"
                                   label="成交数量">
                  </el-table-column>
                  <el-table-column prop="unit"
                                   label="成交单位">
                  </el-table-column>
                  <el-table-column prop="singleprice"
                                   label="单价">
                  </el-table-column>
                  <el-table-column prop="tax_rep_amount"
                                   label="总价">
                  </el-table-column>
                  <el-table-column prop="currency"
                                   label="币制">
                  </el-table-column>
                  <el-table-column prop="sourcearea"
                                   label="原产国（地区）">
                  </el-table-column>
                  <el-table-column prop="destcountry"
                                   label="最终目的国">
                  </el-table-column>
                  <el-table-column prop=""
                                   label="征免方式">
                  </el-table-column>
                  <el-table-column prop=""
                                   label="监管要求">
                  </el-table-column>
                </el-table>
              </div>
              <div v-for="(proItem,j) of products"
                   :key="j"
                   class="mb_20">
                <table class="table_wrap_1" v-if="j === productsIndex" style="border-collapse:separate; border-spacing:0px 0px;">
                  <tr>
                    <td class="newleft">项号</td>
                    <td>{{j + 1}}</td>
                    <td class="newleft">
                      备案序号
                    </td>
                    <td>{{proItem.sort}}</td>
                    <td class="newleft">
                      商品编号
                    </td>

                    <td>{{proItem.hscode}}</td>
                  </tr>
                  <tr>
                    <td class="newleft">检验检疫名称</td>
                    <td></td>
                    <td class="newleft">商品名称</td>
                    <td>
                      {{proItem.ch}}
                    </td>
                    <td class="newleft">
                      规格型号
                    </td>

                    <td colspan="4" >
                      规格:{{proItem.factors1}}; 型号:{{proItem.model}}
                    </td>

                  </tr>
                  <tr>
                    <td class="newleft">成交数量</td>
                    <td>
                      <input type="text" v-model="proItem.qtt" style="width: 100%">
                      <!--                  {{proItem.qtt}}-->
                    </td>
                    <td class="newleft">
                      成交计量单位
                    </td>
                    <td @click="declareUnitChange(j, proItem)">
                      {{proItem.unit}}
                    </td>
                    <td class="newleft">
                      单价
                    </td>

                    <td>
                      <!--                  {{proItem.singleprice}}-->
                      <input type="text" v-model="proItem.singleprice" style="width: 100%">
                    </td>

                  </tr>
                  <tr>
                    <td class="newleft">总价</td>
                    <td>
                      <!--                  {{proItem.tax_rep_amount}}-->
                      <input type="text" v-model="proItem.tax_rep_amount" style="width: 100%">
                    </td>
                    <td class="newleft">币制</td>
                    <td>
                      <!--                  {{proItem.currency}}-->
                      <el-select v-model="proItem.currency"
                                 default-first-option
                                 filterable>
                        <el-option v-for="(curItem,curIndex) of currencyData"
                                   :key="curIndex"
                                   :label="curItem.ch"
                                   :value="curItem.ch" />
                      </el-select>
                    </td>
                    <td class="newleft">法定第一数量</td>

                    <td>
                      <!--                  {{proItem.legalqtt}}-->
                      <input type="text" v-model="proItem.legalqtt" style="width: 100%">
                    </td>
                  </tr>
                  <tr>
                    <td class="newleft">
                      法定第一计量单位
                    </td>
                    <td>{{proItem.legalunit}}</td>
                    <!--                    <td @click="legalOneUnitChange(j, proItem)">{{proItem.legalunit}}</td>-->
                    <td class="newleft">
                      加工成品单耗版本号
                    </td>
                    <td>
                      <input type="text">
                    </td>
                    <td class="newleft">货号</td>

                    <td>
                      <input type="text">
                    </td>
                  </tr>
                  <tr>
                    <td class="newleft">最终目的国（地区）</td>
                    <td>
                      <!--                  {{proItem.destcountry}}-->
<!--                      <el-select v-model="proItem.destcountry" default-first-option filterable style="width: 100%">-->
<!--                        <el-option v-for="(aimItem,aimIndex) of countryData" :key="aimIndex" :label="aimItem.name" :value="aimItem.name"/>-->
<!--                      </el-select>-->
                      {{proItem.destcountry}}
                    </td>
                    <td class="newleft">法定第二数量</td>
                    <td>
                      <input type="text" v-model="proItem.legalqtt2" />
                      <!--                  {{proItem.legalqtt2}}-->
                    </td>
                    <td class="newleft">
                      法定第二计量单位
                    </td>

                    <td>{{proItem.legalunit2}}</td>
                  </tr>
                  <tr>
                    <!--                    <td @click="legalTwoUnitChange(j, proItem)">{{proItem.legalunit2}}</td>-->
                    <td class="newleft">原产国（地区）</td>
                    <td @click="showGoodsSourceDialog(j, proItem)">{{proItem.sourcearea}}</td>

                    <td colspan="2"></td>
                    <td class="newleft">境内货源地</td>
                    <td colspan="2" @click="showGoodsSourceDialog(j, proItem)">{{proItem.sourcearea}}</td>
                  </tr>
                  <tr>
                    <td class="newleft">产地代码</td>
                    <td colspan="2"></td>
                    <td class="newleft">征免方式</td>
                    <td>
                      <el-select v-model="order.dutymode" style="width: 100%">
                        <el-option v-for="(item, index) of zmfsList" :key="index" :label="item.name" :value="item.code"/>
                      </el-select>
                    </td>
                  </tr>
                </table>
              </div>
            </el-col>

            <el-col :span="4" class="bg">
              <div class="flex" style="display: block">
                <div class="mr_10 w_100">
                  <div class="flex  mb_10">
                  </div>
                  <div class="mb_10" style="height: 230px; background: #e1f0ff">
                    <el-table :data="tableData"
                              border
                              style="width: 100%"
                              :header-cell-style="{
                          'background-color': '#303133',
                          'color': '#fff',
                          'text-align':'center'
                      }">
                      <el-table-column prop="member_nickname"
                                       label="集装箱号">
                      </el-table-column>
                      <el-table-column prop="member_nickname"
                                       label="集装箱规格">
                      </el-table-column>
                      <el-table-column prop="member_nickname"
                                       label="拼箱标识">
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="">
                    <table class="table_wrap">
                      <tr>
                        <td class="newleft">集装箱号</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">集装箱规格</td>
                        <td colspan="2"></td>

                      </tr>
                      <tr>
                        <td class="newleft">
                          自重（KG）
                        </td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">拼箱标识</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">商品项号关系</td>
                        <td colspan="2"></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="mr_10 w_100">
                  <div class="mb_10" style="height: 230px; background: #e1f0ff">
                    <el-table :data="tableData"
                              border
                              style="width: 100%"
                              :header-cell-style="{
                          'background-color': '#303133',
                          'color': '#fff',
                          'text-align':'center'
                      }">
                      <el-table-column prop="member_nickname"
                                       label="单证代码">
                      </el-table-column>
                      <el-table-column prop="member_nickname"
                                       label="单证编号">
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="">
                    <table class="table_wrap">
                      <tr>
                        <td class="newleft">随附单证代码</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">随附单证编码</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">
                          关联报关单
                        </td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">关联备案</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">保税/监管场地</td>
                        <td colspan="2"></td>
                      </tr>
                      <tr>
                        <td class="newleft">场地代码</td>
                        <td colspan="2"></td>
                      </tr>
                    </table>
                  </div>
                </div>

              </div>
              <div style="background: rgb(225, 240, 255)">
                <div class="" style="font-size: 14px">
                  总价：
                </div>
                <div style="font-size: 14px">
                  成交数量合计：
                </div>
                <div style="font-size: 14px">
                  法定第一数量合计：
                </div>
                <div style="font-size: 14px">
                  法定第二数量合计：
                </div>
              </div>
            </el-col>
          </el-row>


    </el-card>

    <el-form :model="billParams"
             :rules="billRules"
             ref="billParams"
             label-width="110px"
             class="demo-ruleForm">
      <el-dialog width="30%"
                 title="录入提单"
                 :visible.sync="billDialog">
        <el-form-item label="手册号"
                      prop="trade_register_num">
          <el-input v-model="billParams.trade_register_num"></el-input>
        </el-form-item>
        <el-form-item label="提单号"
                      prop="loading_bill_number">
          <el-input v-model="billParams.loading_bill_number"></el-input>
        </el-form-item>
        <el-form-item label="抵运国"
                      prop="arrive_country">
          <el-input v-model="billParams.arrive_country"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="抵运国编码"
                      prop="arrive_country_code">
          <el-input v-model="billParams.arrive_country_code"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="指运港"
                      prop="loading_port">
          <el-select @change="portChange"
                     v-model="billParams.loading_port"
                     filterable
                     placeholder="请选择指运港">
            <el-option v-for="(porItem,i) of portData"
                       :key="i"
                       :label="porItem.port_ch"
                       :value="porItem.port_ch"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指运港编码"
                      prop="code_of_loading_port">
          <el-input v-model="billParams.code_of_loading_port"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联运输方式"
                      prop="shipping_type">
          <el-select @change="transportChange"
                     v-model="billParams.shipping_type"
                     filterable
                     placeholder="请选择联运输方式">
            <el-option v-for="(traItem,i) of transportData"
                       :key="i"
                       :label="traItem.name"
                       :value="traItem.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式编码"
                      prop="trafmode">
          <el-input v-model="billParams.trafmode"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="运输工具名称"
                      prop="conveyance_name">
          <el-input v-model="billParams.conveyance_name"></el-input>
        </el-form-item>
        <el-form-item label="航次号"
                      prop="voyage_number">
          <el-input v-model="billParams.voyage_number"></el-input>
        </el-form-item>
        <el-form-item label="箱号[S]"
                      prop="container_number_s">
          <el-input v-model="billParams.container_number_s"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="箱号[L]"
                      prop="container_number_l">
          <el-input v-model="billParams.container_number_l"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="billConfirm('billParams')">确定</el-button>
          <el-button @click="billDialog = false">取 消</el-button>
        </el-form-item>
      </el-dialog>
    </el-form>

    <el-dialog title="其他包装信息" :visible.sync="packagingDialogVisible">
      <el-table ref="multipleTable" :data="packagesOtherData" border style="width: 100%" @select="selectPackaging">

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="包装材料种类名称"></el-table-column>
        <el-table-column prop="code" label="包装材料种类代码"></el-table-column>

        <!--        <el-table-column label="操作">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="text" size="small"@click="handlePackaging(scope.row)">选择</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="packagingDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="packagingBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="价格说明" :visible.sync="priceDialogVisible" width="700px">
      <el-form label-width="250px">
        <el-form-item label="特殊关系确认">
          <el-select v-model="order.promiseitmes.relationship">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) in whetherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格影响确认">
          <el-select v-model="order.promiseitmes.influence">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) in whetherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="与货物有关的特许权使用费支付确认">
          <el-select v-model="order.promiseitmes.cost">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) in whetherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公示定价确认">
          <el-select v-model="order.promiseitmes.publicity">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) in whetherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="暂定价格确认">
          <el-select v-model="order.promiseitmes.provisional">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) in whetherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="priceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="priceBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="通过审核"
               :visible.sync="pass_dialog"
               width="30%">
      <div class="mb_20 flex flex_center">
        <div class="ipt_label mr_10">
          手册号:
        </div>
        <div class="ipt_220">
          <el-input v-model="auditingParams.trade_register_num"
                    placeholder="请输入手册号"></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="pass_dialog = false">取 消</el-button>
        <el-button @click="showBillDialog"
                   type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核不通过"
               :visible.sync="cancel_dialog"
               width="30%">
      <div class="mb_20">
        <div class="mb_20">原因</div>
        <el-input v-model="cancelParams.mark"
                  type="textarea"></el-input>
      </div>
      <span slot="footer">
        <el-button @click="cancel_dialog = false">取 消</el-button>
        <el-button @click="cancleConfirm"
                   type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="申报地海关"
      :visible.sync="declarePortDialog"
    >
      <thePort @portSelected="portSelected"></thePort>
      <div slot="footer" class="dialog_footer">
        <el-button @click="declarePortDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="出境关别"
      :visible.sync="exitPortDialog"
    >
      <thePort @portSelected="portSelected"></thePort>
      <div slot="footer" class="dialog_footer">
        <el-button @click="exitPortDialog = false">关 闭</el-button>
      </div>
    </el-dialog>



    <el-dialog
      title="我的境外收货人"
      :visible.sync="receiverDialog"
    >
      <theReceiver @receiverSelected="receiverSelected" :countryData="countryData"></theReceiver>
      <div slot="footer" class="dialog_footer">
        <el-button @click="receiverDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="unitType == 1? '法定单位(必须与税票单位一致)':'法定单位'"
      :visible.sync="unitDialog"
      width="40%"
    >
      <theUnit @unitSelected="unitSelected"></theUnit>
    </el-dialog>

    <el-dialog
      title="境内货源地"
      :visible.sync="sourceOfGoodsDialog"
    >
      <sourceOfGoods @sourceOfGoodsSelected="sourceOfGoodsSelected"></sourceOfGoods>
      <div slot="footer" class="dialog_footer">
        <el-button @click="sourceOfGoodsDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="离境口岸"
      :visible.sync="leavePortDialog"
    >
      <portLeave @leaveSelected="leaveSelected"></portLeave>
    </el-dialog>

    <el-dialog
      title="我的联系人"
      :visible.sync="contacterDialog"
    >
      <theContacter @contacterSelect="contacterSelect"  ></theContacter>
      <div slot="footer" class="dialog_footer">
        <el-button @click="contacterDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/config";
  import thePort from '@/components/common/thePort.vue';//申报地海关，出境关别
  import theReceiver from '@/components/common/theReceiver.vue';
  import entreport from "../../../static/js/entreport";
  import theUnit from '@/components/common/theUnit.vue';//单位
  import sourceOfGoods from '@/components/common/sourceOfGoods.vue';//货源地
  import theContacter from '@/components/common/theContacter.vue';//联系人
  import portLeave from '@/components/common/portLeave.vue';//离境口岸
  //收货人
  export default {
    inject: ["reload"],
    components: {
      thePort,
      theReceiver,
      theUnit,
      sourceOfGoods,
      theContacter,
      portLeave,
    },
    data() {
      return {
        packagingDialogVisible: false,
        priceDialogVisible: false,
        whetherList: [{
          name: "是", code: "1"
        }, {
          name: "否", code: "0"
        }],

        bgdlxList: [{
          name: "有纸化报关", code: "0"
        }, {
          name: "无纸带清单报关", code: "D"
        }, {
          name: "有纸带清单报关", code: "L"
        }, {
          name: "通关无纸化", code: "M"
        }, {
          name: "无纸报关", code: "W"
        }],
        zmfsList: [{
          name: "照章征税", code: "1"
        }, {
          name: "折半征税", code: "2"
        }, {
          name: "全免", code: "3"
        }, {
          name: "特案", code: "4"
        }, {
          name: "征免性质", code: "5"
        }, {
          name: "保证金", code: "6"
        }, {
          name: "保函", code: "7"
        }, {
          name: "折半补税", code: "8"
        }, {
          name: "全额退税", code: "9"
        }],
        uploadUrl: config.baseUrl + "/admin/uploadimg",
        baseImgUrl: config.baseImgUrl,
        productMsg: {},

        portParams: {
          name: ""
        },
        portData: [],
        transportData: [],

        auditingParams: {
          id: 0,
          status: 3,
          trade_register_num: '',
        },

        cancelParams: {
          id: this.$route.query.id - 0,
          status: 2,
          mark: '',
        },
        cancel_dialog: false,

        pass_dialog: false,
        no_pass_dialog: false,
        billParams: {},
        billDialog: false,
        billRules: {
          loading_bill_number: [
            { required: true, message: '请输入提单号', trigger: 'blur' },
          ],
          loading_port: [
            { required: true, message: '请选择指运港', trigger: 'blur' },
          ],
          shipping_type: [
            { required: true, message: '请选择连运输方式', trigger: 'blur' },
          ],
          conveyance_name: [
            { required: true, message: '请输入运输工具名称', trigger: 'blur' },
          ],
          voyage_number: [
            { required: true, message: '请输入航次号', trigger: 'blur' },
          ],
        },

        isBillChange: false,

        historyFile: [],
        historyImageUrl: "",
        historyVisible: false,

        shippingFile: [],
        shippingImageUrl: "",
        shippingVisible: false,

        otherFile: [],
        otherImageUrl: "",
        otherVisible: false,

        order: {
          contract_type_info: {},
          contact: {},
          receiver: {},
          priceterm_info: {},
          package1: {},
          // otherPackage: [],
          procontact: [],
        },
        products: [],
        steps: 0,
        activeName: "报关表头",
        tabsList: [
          { label: "待受理" },
          { label: "待补充信息" },
          { label: "受理中" },
          { label: "报送中" },
          { label: "待报关" },
          { label: "已放行" },
          { label: "结关" },
          { label: "待签函" },
          { label: "待收汇" },
          { label: "待寄发票" },
          { label: "待退税" },
          { label: "已退税" },
          { label: "已完成" }
        ],
        tabsList1: [
          { label: "待受理" },
          { label: "待补充信息" },
          { label: "受理中" },
          { label: "报送中" },
          { label: "待报关" },
          { label: "查验" },
          { label: "已放行" },
          { label: "结关" },
          { label: "待签函" },
          { label: "待收汇" },
          { label: "待寄发票" },
          { label: "待退税" },
          { label: "已退税" },
          { label: "已完成" }
        ],
        isCheck:"",
        tableData: [],


        declarePortDialog: false,
        isDeclarePortSelected: true,//选择申报口岸
        exitPortDialog: false,


        receiverDialog: false,
        countryData: [],

        entreportData: entreport,
        productIndex: 0,
        unitType: 1,
        unitDialog: false,

        sourceOfGoodsDialog: false,
        currencyData: [],

        productsIndex: 0,
        packagesData: [],
        packagesOtherData: [{
          name: "散装", code: "00"
        }, {
          name: "裸装", code: "01"
        }, {
          name: "球状罐类", code: "04"
        }, {
          name: "包/袋", code: "06"
        }, {
          name: "纸制或纤维板制盒/箱", code: "22"
        }, {
          name: "木质或竹藤等植物性材料制盒/箱", code: "23"
        }, {
          name: "其他材料制盒/箱", code: "29"
        }, {
          name: "纸制或纤维板制桶", code: "32"
        }, {
          name: "木制或竹藤等植物性材料制桶", code: "33"
        }, {
          name: "其他材料制桶", code: "39"
        }, {
          name: "再生木托", code: "92"
        }, {
          name: "天然木托", code: "93"
        }, {
          name: "植物性铺垫材料", code: "98"
        }, {
          name: "其他包装", code: "99"
        }],
        promiseitmes: {
          relationship: "9",
          influence: "9",
          cost: "9",
          publicity: "9",
          provisional: "9",
        },
        leavePortDialog: false,
        contacterDialog: false,

        sbdhgList: [],
        packagingArr: []
      };
    },
    computed:{
      headers(){
        return{
          'token':sessionStorage.token_admin
        }
      }
    },
    created() {
      this.getOrder();
    },
    methods: {
      // print( ) {
      //   let {href} = this.$router.resolve({
      //     path: "/print",
      //     query: {id: this.order.id, type: "报关单"}
      //   });
      //   window.open(href, "_blank");
      // },
      print() {
        let { href } = this.$router.resolve({
          path: "/print",
          query: {
            id: this.$route.query.id,
            type: "放行单"
          }
        });
        window.open(href, "_blank");
      },
      // 获取订单详情
      getOrder() {
        const id = this.$route.query.id;
        this.$axios
          .get(`/admin/orderCheck/selectOrder?id=${id}`)
          .then(res => {
            if (res.status == 200) {
              res = res.data.info;
              console.log(JSON.parse(res.order.promiseitmes))
              console.log(res.order.promiseitmes)
              this.order = {
                ...res.order,
                contact:res.order.contact?JSON.parse(res.order.contact):'',
                contract_type_info: JSON.parse(res.order.contract_type_info),
                custom_type_info: JSON.parse(res.order.custom_type_info),
                package1: JSON.parse(res.order.package1),
                priceterm_info: JSON.parse(res.order.priceterm_info),
                // receiver: JSON.parse(res.order.receiver),
                procontact: JSON.parse(res.order.procontact),
                // promiseitmes: JSON.parse(res.order.promiseitmes),
                entrytype:res.order.entrytype=="0"? "有纸化报关":(res.order.entrytype== 'D' ? "无纸带清单报关":
                  (res.order.entrytype=='L'? "有纸带清单报关":(res.order.entrytype=='M'? "通关无纸化":(res.order.entrytype=='W'? "无纸报关":""))))
              };
              if(res.order.receiver){
                this.order.receiver=JSON.parse(res.order.receiver)
              }

              if(null !=res.order.promiseitmes){
                this.order.promiseitmes=JSON.parse(res.order.promiseitmes)
              }else{
                this.order.promiseitmes=this.promiseitmes;
              }
              if (this.order.apply_at) {
                this.order.apply_at1 = this.formatDate(this.order.apply_at)
              }
              debugger
              if(res.order.priceterm_info) {
                let fare = JSON.parse(res.order.priceterm_info).fare;
                let fareName = "";
                if (fare) {
                  if ("1" == fare.type) {
                    fareName = "汇率:";
                  } else if ("2" == fare.type) {
                    fareName = "单价:";
                  } else if ("3" == fare.type) {
                    fareName = "总价:";
                  }
                  if (fare.amount) {
                    fareName += fare.amount;
                  }
                  if (fare.unit) {
                    fareName += " " + fare.unit;
                  }
                }
                this.order.priceterm_info_fare = fareName;

                let premium = JSON.parse(res.order.priceterm_info).premium;
                let premiumName = "";
                if (premium) {
                  if ("1" == premium.type) {
                    premiumName = "汇率:";
                  } else if ("2" == premium.type) {
                    premiumName = "单价:";
                  } else if ("3" == premium.type) {
                    premiumName = "总价:";
                  }
                  if (premium.amount) {
                    premiumName += premium.amount;
                  }
                  if (premium.unit) {
                    premiumName += " " + premium.unit;
                  }
                }
                this.order.priceterm_info_premium = premiumName;


                let incidental = JSON.parse(res.order.priceterm_info).incidental;
                let incidentalName = "";
                if (incidental) {
                  if ("1" == incidental.type) {
                    incidentalName = "汇率:";
                  } else if ("2" == incidental.type) {
                    incidentalName = "单价:";
                  } else if ("3" == incidental.type) {
                    incidentalName = "总价:";
                  }
                  if (incidental.amount) {
                    incidentalName += incidental.amount;
                  }
                  if (incidental.unit) {
                    incidentalName += " " + incidental.unit;
                  }
                }
                this.order.priceterm_info_incidental = incidentalName;
              }
              //         订单状态(1已完成，2待补充信息，3受理中，4待签函，5待报关，6
              // 待收汇，7待寄发票，8待退税，9已退税，10待受理，11，取消订单，12报送中，13草稿，14初审通过，15，已放行，16结关，17失败)
              this.steps = res.order.status == 10 ? 0 :
                res.order.status == 2 ? 1 :
                  res.order.status == 3 ? 2 :
                    res.order.status == 12 ? 3 :
                      res.order.status == 5 ? 4 :
                        res.order.status == 15 ? 5 :
                          res.order.status == 16 ? 6 :
                            res.order.status == 4 ? 7 :
                              res.order.status == 6 ? 8 :
                                res.order.status == 7 ? 9 :
                                  res.order.status == 8 ? 10 :
                                    res.order.status == 9 ? 11 :
                                      res.order.status == 1 ? 12 : -1;
              this.products = res.products.map(item => {
                let factors1 = '';
                item.factors = JSON.parse(item.factors);
                for (let k in item.factors) {
                  factors1 += `${item.factors[k]}|`;
                }
                factors1 = factors1.replace(/\|$/, '');
                let obj = {
                  ...item,
                  currency: res.order.currency,
                  destcountry: res.order.destcountry,
                  factors1,
                };
                return obj;
              });
              // this.products = res.products
              this.isCheck=res.isCheck;

              let totalRoughWeight = 0;
              let totalNetWeight = 0;
              let totalCubicNumber = 0;
              let totalPrice = 0;
              res.products.forEach(item => {
                totalRoughWeight += (item.gwkg - 0);
                totalNetWeight += (item.nwkg - 0);
                totalCubicNumber += (item.cubic_number - 0);
                totalPrice += (item.tax_rep_amount - 0);
              });
              this.productMsg = {
                totalRoughWeight: totalRoughWeight.toFixed(2),
                totalNetWeight: totalNetWeight.toFixed(2),
                totalCubicNumber: totalCubicNumber.toFixed(2),
                totalPrice: totalPrice.toFixed(2),
              };

              res.attachs.forEach(item => {
                if (item.title == '历史报关单') {
                  this.historyFile.push(item);
                }
                if (item.title == 'shipping Order') {
                  this.shippingFile.push(item);
                }
                if (item.title == '其他附件') {
                  this.otherFile.push(item);
                }
              });
              setTimeout(() => {
                window.print()
              }, 1000)
            }
          });
      },
      print_fxd( ) {
        let {href} = this.$router.resolve({
          path: "/print",
          query: {id:  this.order.id, type: "放行单"}
        });
        window.open(href, "_blank");
      },
      print1( ) {
        let {href} = this.$router.resolve({
          path: "/print1",
          query: {id: this.$route.query.id}
        });
        window.open(href, "_blank");
      },
      formatDate(date) {
        var date = new Date(date);
        var YY = date.getFullYear() + '-';
        var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD +" "+hh + mm + ss;
      },
      // netWeightChange(val, index) {//计算总净重
      //   // let products = JSON.parse(JSON.stringify(this.products))
      //   // let totalNetWeight = 0;
      //   // if (val) {
      //   //   let gwkg = val.gwkg
      //   //   let nwkg = val.nwkg
      //   //   if (gwkg * 1 > 0 && gwkg * 1 < nwkg * 1) {
      //   //     this.$message.error(`第${index + 1}项产品的毛重必须大于等于净重，请重新输入`)
      //   //     this.products[index].nwkg = 0
      //   //     this.products[index].gwkg = 0
      //   //   }
      //   // }
      //   this.calcTotalMJ()
      // },
      //
      // roughWeightChange(val, index) {//计算总毛重
      //   // let products = JSON.parse(JSON.stringify(this.products))
      //   // let totalRoughWeight = 0;
      //   // if (val) {
      //   //   let gwkg = val.gwkg
      //   //   let nwkg = val.nwkg
      //   //   if (nwkg * 1 > 0 && gwkg * 1 < nwkg * 1) {
      //   //     this.$message.error(`第${index + 1}项产品的毛重必须大于等于净重，请重新输入`)
      //   //     this.products[index].nwkg = 0
      //   //     this.products[index].gwkg = 0
      //   //   }
      //   // }
      //   this.calcTotalMJ()
      // },
      //
      // // 计算总净重总毛重
      // calcTotalMJ() {
      //   let totalRoughWeight = 0
      //   let totalNetWeight = 0
      //   let list = [...this.products]
      //   this.$nextTick(() => {
      //     for (let i = 0; i < list.length; i++) {
      //       let item = list[i]
      //       item.gwkg = item.gwkg === undefined ? 0 : item.gwkg
      //       item.nwkg = item.nwkg === undefined ? 0 : item.nwkg
      //       if ((item.gwkg > 0 && item.nwkg > 0) && (item.gwkg < item.nwkg)) {
      //         item.nwkg = 0
      //         item.gwkg = 0
      //         this.$set(this.products, i, item)
      //         this.$message.error(`第${i + 1}项产品的毛重必须大于等于净重，请重新输入`)
      //       }
      //       totalRoughWeight += item.gwkg === undefined ? 0 : item.gwkg
      //       totalNetWeight += item.nwkg === undefined ? 0 : item.nwkg
      //     }
      //     this.$set(this.productMsg, 'totalRoughWeight', parseFloat(totalRoughWeight).toFixed(2));
      //     this.$set(this.productMsg, 'totalNetWeight', parseFloat(totalNetWeight).toFixed(2));
      //   })
      // },
    }
  };
</script>

<style scoped>
  .file_name {
    width: 12.5%;
    padding: 0 10px;
    text-align: right;
    box-sizing: border-box;
  }

  .table_wrap,
  .table_wrap_1 {
    width: 100%;
    border: 1px solid #ebeef5;
    font-size: 14px;
    color: #000;
    border-right: 0;
    border-bottom: 0;
  }

  .table_wrap td,
  .table_wrap_1 td {
    width: 12.5%;
    border-right: 1px solid #ebeef5;
    padding: 0 6px;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    overflow: hidden;
    white-space: normal;
    word-break: break-all;
    line-height: 22px;
  }
  .table_wrap_1 td {
    width: 10% !important;
  }
  .demo-inputParams .el-select {
    width: 100%;
  }
  .text_r {
    text-align: right;
  }
  .ddinfo {
    font-size: 14px;
    color: #606266;
  }
  .ddinfo .el-row {
    line-height: 30px;
  }
  .ddinfo .el-col {
    height: 30px;
  }
  .mgsp10 span {
    margin: 0 10px;
  }
  h4 {
    padding: 20px;
  }
  .newleft {
    background: #fcffda;
  }

  .tipsTop {
    margin: 20px 0 4px 0;
  }
  .tipsTop span {
    font-size: 16px;
    margin-right: 100px;
  }
</style>
<style>

  .hs .el-input__inner {
    border: none;
  }
  .newleft input {
    background: none;
  }
  .hs .table_wrap td, .hs .table_wrap_1 td {
    line-height: normal;
    font-size: 12px;
  }
  .hs .table_wrap td {
    /*border-color: #b7b7b7;*/
  }
  .hs .el-table__header,  .hs .el-table__body {
    width: auto!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/print1.vue